/**
* When a form is loaded, enable any help text that appears on the page.
*/
define('controllers/helpText',[], function() {
	var controller = Marionette.Object.extend( {
		initialize: function() {
			this.listenTo( nfRadio.channel( 'form' ), 'render:view', this.initHelpText );
			this.listenTo( nfRadio.channel( 'field-repeater' ), 'fieldset:added', this.initHelpText );

			nfRadio.channel( 'form' ).reply( 'init:help', this.initHelpText );
		},

		initHelpText: function( view ) {

			if(view && !view.el && typeof view.get === 'function'){
				//Catch repeater fieldset added event
				if(view.get("type") === "repeater"){
					view.el = "#nf-form-" + view.get("formID") + "-cont";
				}
			}

			jQuery( view.el ).find( '.nf-help' ).each( function(el) {
				var jBox = jQuery( this ).jBox( 'Tooltip', {
					theme: 'TooltipBorder',
					content: jQuery( this ).data( 'text' ),
					trigger: 'mouseenter focus',
					closeOnMouseleave: true,
					closeOnClick: true
				});
			// Hide tooltip on keydown and mouseleave
			jQuery(this).on('keydown mouseleave', function() {
				jBox.close();
			});
			} );
		}
	});

	return controller;
 } );

